<motif-modal-title variant="alt">
  <h3>Downloads
    
  <span>Download document from the below list</span>
  </h3>
  
  
  <button motifIconButton aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon
      [src]="'/assets/icons/navigation/ic_close_24px.svg'"
    ></motif-icon>
  </button>
</motif-modal-title>
<motif-modal-content>
  <div class="docListContainer">
    <p>
      <motif-icon
        [src]="'/assets/icons/editor/ic_insert_drive_file_24px.svg'"
      ></motif-icon
      >Meeting Deck
    </p>
    <motif-icon
      [src]="'/assets/icons/file/ic_file_download_24px.svg'"
    ></motif-icon>
  </div>
  <div class="docListContainer">
    <p>
      <motif-icon
        [src]="'/assets/icons/editor/ic_insert_drive_file_24px.svg'"
      ></motif-icon
      >Action items
    </p>
    <motif-icon
    [src]="'/assets/icons/file/ic_file_download_24px.svg'"
    ></motif-icon>
  </div>
</motif-modal-content>
